import React from 'react';

// Without this, an uncaught render error (e.g. a transient bad payload right after
// the progress page redirects here) unmounts the whole tree and leaves a blank page —
// the only way out was a manual browser refresh. This catches it and offers a retry
// that re-mounts the subtree instead.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled UI error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '100px 24px' }}>
          <h2 style={{ marginBottom: 10 }}>Something went wrong loading this page</h2>
          <p className="text-muted" style={{ marginBottom: 20 }}>
            This is usually temporary. Try again below.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => this.setState({ hasError: false })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
